<template>
  <div
    v-if="dealCompShow"
    v-loading="loading"
    :class="{ 'no-permission': !dealCompCtrl }"
    class="widget-wrapper"
    :style="box"
  >
    <template v-if="showTemplate === 'type-1'">
      <div class="widget-header title">
        <div class="widget-header-title">{{ title }}</div>
        <div class="date-str-span">{{ showDataStr }}</div>
      </div>
      <div class="value-div" :style="{ color: prop?.valueColor }">
        {{ valueObj.currentValue }}
      </div>
      <div v-if="chainRatioValue" class="widget-footer">
        <span class="sub-title">{{ $t('component.chainComparison.preWeekChainTip') }}</span>
        <span class="point-span sub-title" :class="getChainRatioI(valueObj.chainRatioValue)"
          ><svg-icon :icon-class="valueIcon" class="point-i" />{{ valueObj.chainRatioValue }}%</span
        >
      </div>
    </template>
    <template v-else>
      <div class="type-2-wrapper">
        <div class="type-2-layout-wrapper title">
          <div class="title-text-wrapper">{{ title }}</div>
          <div class="current-value-wrapper" :style="{ color: prop?.valueColor }">
            {{ valueObj.currentValue }}%
          </div>
        </div>
        <div v-if="chainRatioValue" class="type-2-layout-wrapper title">
          <div class="tip-text-wrapper sub-title">
            {{ $t('component.chainComparison.preWeekChainTip') }}
          </div>
          <div
            class="ratio-value-wrapper sub-title"
            :class="getChainRatioI(valueObj.chainRatioValue)"
          >
            <svg-icon :icon-class="valueIcon" class="point-i" />{{ valueObj.chainRatioValue }}%
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script lang="ts" setup>
  import { computed, defineProps } from 'vue'
  import type { ComponentOperationData } from '@haohan/clw-event'
  import { useCommonForGeneral } from '@haohan/clw-hooks'

  const props = defineProps<{
    item: Widget
  }>()

  const {
    dealCompShow,
    dealCompCtrl,
    prop,
    box,
    data,
    queryRangs,
    loading,
    reloadByEvent,
    onlyReceiveEvent
  } = useCommonForGeneral(props, {
    listenerEventOperation,
    getEventValueCanUseObj
  })

  const showTemplate = computed(() => {
    return prop.value?.showTemplate ? prop.value.showTemplate : 'type-1'
  })
  const title = computed(() => {
    return prop.value?.title
  })
  const valueObj = computed(() => {
    const result = {
      currentValue: 0,
      chainRatioValue: 0
    }
    if (data.value && data.value.content.length > 0) {
      result.currentValue = data.value.content[0][prop.value?.currentValue] || 0
      result.chainRatioValue = data.value.content[0][prop.value?.chainRatioValue] || 0
    }
    return result
  })
  const valueIcon = computed(() => {
    try {
      if (Number(valueObj.value.chainRatioValue) < 0) {
        return 'down-triangle'
      }
      return 'up-triangle'
    } catch (e: any) {
      return 'up-triangle'
    }
  })
  const chainRatioValue = computed(() => {
    return prop.value?.chainRatioValue
  })
  const showDataStr = computed(() => {
    if (queryRangs.value.length === 0) {
      return ''
    }
    return getQueryDayStr(queryRangs.value[0])
  })
  function getChainRatioI(value: number) {
    if (value < 0) {
      return {
        'down-color': true,
        'el-icon-caret-bottom': true
      }
    }
    return {
      'up-color': true,
      'el-icon-caret-top': true
    }
  }
  function getQueryDayStr(rang: any) {
    if (rang.begin === rang.end) {
      return `${rang.begin.substring(4, 6)}-${rang.begin.substring(6, 8)}`
    }
    return `${rang.begin.substring(4, 6)}-${rang.begin.substring(6, 8)}至${rang.end.substring(
      4,
      6
    )}-${rang.end.substring(6, 8)}`
  }
  /**
   * 获取可供交互使用的事件值
   */
  function getEventValueCanUseObj() {
    return {}
  }
  /**
   * 根据操作方法执行组件中对应的事件值
   * @param operation 操作方法key
   * @param data 交互值
   */
  function listenerEventOperation(operation: string, operationData: ComponentOperationData) {
    if (operation === 'reloadByEvent') {
      reloadByEvent()
    } else if (operation === 'onlyReceiveEvent') {
      onlyReceiveEvent()
    }
  }
</script>

<style lang="scss" scoped>
  .widget-wrapper {
    overflow: hidden;
    color: var(--font-color-content);
    -webkit-transition: 0.3s;
    transition: 0.3s;
    padding: 15px 10px 10px 10px;
    width: 100%;
    .widget-header {
      font-size: 14px;
      display: flex;
      .widget-header-title {
        flex-grow: 1;
      }
    }
    .widget-footer {
      font-size: 12px;
      .point-span {
        display: block;
        float: right;
      }
    }
    .point-i {
      font-size: 12px;
      margin-right: 5px;
    }
    .date-str-span {
      font-size: 12px;
      line-height: 20px;
    }
    .value-div {
      text-align: center;
      font-size: 28px;
      line-height: 70px;
    }
    .up-color {
      color: #32b067 !important;
    }
    .down-color {
      color: #dd2e3d !important;
    }
    .type-2-wrapper {
      .type-2-layout-wrapper {
        display: flex;
        margin-bottom: 5px;
        &:last-child {
          margin-bottom: 0;
        }
        .title-text-wrapper {
          font-size: 14px;
        }
        .current-value-wrapper {
          font-size: 15px;
        }
        .tip-text-wrapper,
        .ratio-value-wrapper {
          font-size: 12px;
        }
        .title-text-wrapper,
        .tip-text-wrapper {
          text-align: left;
        }
        .current-value-wrapper,
        .ratio-value-wrapper {
          text-align: right;
          flex-grow: 1;
        }
      }
    }
  }
</style>
